import React from 'react';

/* Campo de valor em R$ com máscara: 1.234.567,89 enquanto digita.
   Os dígitos entram pela direita, como em caixa de banco (digitar 748775 dá
   7.487,75). O valor que sai continua no formato que o resto do sistema já
   usa: texto com ponto decimal ("7487.75"), ou '' quando vazio. */
const formatar = (v) => (v === '' || v === null || v === undefined || Number.isNaN(Number(v))
  ? '' : Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

function CampoMoeda({ value, onChange, ...resto }) {
  return (
    <input
      {...resto}
      type="text"
      inputMode="numeric"
      value={formatar(value)}
      onChange={e => {
        const digitos = e.target.value.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
        onChange(digitos ? String(Number(digitos) / 100) : '');
      }}
    />
  );
}

export default CampoMoeda;
